import styled from 'styled-components';

export const Title = styled.h2`
  margin: 0;
  line-height: 40px;
`;

export const Heading = styled.div`
  display: flex;
  flex-direction: row;
  margin: 0 0 8px 0;
`;

export const Container = styled.div`
  margin: 0 0 2rem 0;
  position: relative;
`;
